export default "__VITE_ASSET__BGXFqckz__"